import { useMatch } from "react-router";
import EditWebhookForm from "../../../organisms/Webhook/EditWebhookForm";
import { Paper } from "@mui/material";

export default function EditWebhookPage() {
  const match = useMatch("/m/settings/integrations/webhooks/:webhookId");
  const webhookId = match?.params.webhookId || "";

  return (
    <Paper>
      <EditWebhookForm _id={webhookId} />
    </Paper>
  );
}
